import { Divider } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

export function ShiftCardDivider() {
  return (
    <Box sx={{ paddingY: 5 }}>
      <Divider color="primary" />
    </Box>
  );
}
